<template>
  <div class="content_menu clearfix">
    <div class="left" style="width:343px">
      <div class="left" style="width:178px;">
        <TheFoodMenu active="hotdogs" />
      </div>

      <div class="left" style="margin:0px 0 0 27px;">
        <img src="/assets/images/titles/menu_left_hotdog.png">
      </div>

      <br clear="all" />
    </div>

    <div class="right" style="width:552px; margin:8px 0px 0 0;">
      <div class="left" style="width:522px; height:117px;">
        <img src="/assets/images/menu_img/hotdogs.png">
      </div>

      <br clear="all" />

      <div class="product-container">
        <ProductList :products="products" />

        <br clear="all" />

        <div class="left" style="margin:30px 0 0 -60px;">
          <img src="/assets/images/menu_img/menu_img3.png">
        </div>
      </div>

      <div class="menu_right">
        <div class="right" style="margin:-116px 14px 0 0;">
          <img src="/assets/images/menu_img/menu_hotdogs_side.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheFoodMenu from '@/components/TheFoodMenu.vue';
import ProductList from '@/components/ProductList.vue';

export default {
  name: 'HotDogs',

  components: {
    TheFoodMenu,
    ProductList,
  },

  data() {
    return {
      products: [
        {
          id: 1,
          name: 'HOT DOG',
          description: 'Old fashioned 100% all beef frankfurter',
          modifiers: [],
        },
        {
          id: 2,
          name: 'POLISH DOG',
          description: 'Smokehouse skinless beef sausage',
          modifiers: [],
        },
        {
          id: 3,
          name: 'CHILI DOG',
          description: 'With chili and onions',
          modifiers: [],
        },
        {
          id: 4,
          name: 'HOT LINK',
          description: 'Hot ’n’ spicy all beef Louisiana sausage',
          modifiers: [],
        },
      ],
    };
  },
};
</script>
